/**
 * Do not edit directly
 * Generated on Wed, 17 Apr 2024 09:25:51 GMT
 */

export const SDS_MISC_ALPHA_XXSMALL = 0.04; // XX-small alpha channel opacity
export const SDS_MISC_ALPHA_XSMALL = 0.1; // X-small alpha channel opacity
export const SDS_MISC_ALPHA_SMALL = 0.22; // Small alpha channel opacity
export const SDS_MISC_ALPHA_MEDIUM = 0.32; // Medium alpha channel opacity
export const SDS_MISC_ALPHA_LARGE = 0.54; // Large alpha channel opacity
